import { useEffect, useRef } from 'react'
import { AppEventPayloadMap } from '@/events/eventTypes'
import { listenAppEvent } from '@/events/eventBus'

export function useAppEvent<K extends keyof AppEventPayloadMap>(
  eventName: K,
  handler: (detail: AppEventPayloadMap[K]) => void,
) {
  // keep latest handler without re-subscribing every render
  const handlerRef = useRef(handler)
  handlerRef.current = handler

  useEffect(() => {
    return listenAppEvent(eventName, (detail) => handlerRef.current(detail))
  }, [eventName])
}
